import React, { useEffect, useState, useMemo } from 'react';
import { HeaderLayout } from '@layouts';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useMenuContext } from '@hooks';
import { updateMenuSection } from '@api';
import { arrangeMenu } from '@utils/menu';
import ManageMenuItem from '@components/ManageMenuItem';
import { Typography, Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { CustomSwitch } from '@components/ManageMenuItem/ManageMenuItem';

function MenuItem({ item, selected, setSelected }) {
  const classes = useStyles();
  const [checked, updateChecked] = useState(item.enabled);

  const changeItemState = () => {
    updateMenuSection(item.id, item.enabled);
    updateChecked(!checked);
  };

  return (
    <>
      <ListItem button className={classes.item}>
        <ListItemText primary={item.name} />
        <CustomSwitch checked={checked} onChange={changeItemState} />
      </ListItem>
      <List component="div" disablePadding>
        {item.children.map(item => (
          <ManageMenuItem
            selected={selected}
            setSelected={setSelected}
            section={true}
            item={item}
            key={item.id}
          />
        ))}
      </List>
    </>
  );
}

export default function ManageMenu() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [selectedSubmenuItem, setSelectedSubmenuItem] = useState('');

  const {
    fetchedMenu,
    fetchedStructure,
    fetchMenuSectionsListForService,
  } = useMenuContext();

  const arrangedMenu = useMemo(() => arrangeMenu(fetchedStructure), [
    fetchedStructure,
  ]);

  useEffect(() => {
    fetchMenuSectionsListForService();

    setLoading(false);
    if (fetchedMenu?.length === 0 || fetchedStructure?.length === 0) {
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSelectedSubmenuItem(arrangedMenu[0]?.children[0]?.id);
  }, [fetchedStructure, arrangedMenu]);

  return (
    <HeaderLayout>
      {!loading && arrangedMenu.length && (
        <Grid container justify="space-between">
          <Grid md={5} sm={6} lg={4} item className={classes.container}>
            <List
              component="nav"
              aria-labelledby="nested-list-subheader"
              subheader={
                <Typography gutterBottom variant="h4">
                  Menu Sections
                </Typography>
              }
              className={classes.root}
            >
              {arrangedMenu.map(defaultMenu => (
                <MenuItem
                  selected={selectedSubmenuItem}
                  setSelected={setSelectedSubmenuItem}
                  key={defaultMenu.id}
                  item={defaultMenu}
                />
              ))}
            </List>
          </Grid>
          <Grid
            className={classes.itemsContainer}
            direction="column"
            item
            container
            md={7}
            sm={6}
          >
            <Typography variant="h4">
              Items in '
              {`${
                fetchedStructure.find(item => item.id === selectedSubmenuItem)
                  ?.name
              }`}
              '
            </Typography>
            <List component="nav" aria-labelledby="nested-list-subheader">
              {fetchedMenu
                .filter(item => item.menuSection === selectedSubmenuItem)
                .map(item => {
                  return (
                    <ManageMenuItem
                      selected={selectedSubmenuItem}
                      setSelected={setSelectedSubmenuItem}
                      item={item}
                      section={false}
                      key={item.id}
                      itemList
                    />
                  );
                })}
            </List>
          </Grid>
        </Grid>
      )}
    </HeaderLayout>
  );
}
